@if (showSidebar()) {
<main class="grid max-md:grid-cols-[3.5rem_minmax(0,1fr)] md:grid-cols-[max-content_minmax(0,1fr)] grid-rows-[1fr] w-full max-w-[100vw]">
  <app-sidebar class="col-start-1 row-start-1 h-screen sticky top-0 z-[100]" />
  <div class="col-start-2 row-start-1 min-w-0 w-full overflow-x-hidden">
    <router-outlet></router-outlet>
  </div>
</main>
} @else {
<main class="w-full h-full">
  <router-outlet></router-outlet>
</main>
}

<!-- Global Confirmation Dialog -->
<app-confirmation-dialog
  [visible]="confirmationService.isVisible()"
  [title]="confirmationService.title()"
  [message]="confirmationService.message()"
  [buttons]="confirmationService.buttons()"
  (emitOnClick)="confirmationService.onDialogAction($event)"
  (visibleChange)="confirmationService.closeDialog()"
></app-confirmation-dialog>

@if (showSidebar()) {
  <!-- Product-search assistant, hidden on the login page (showSidebar also tracks
       "not logged out" today) since it needs an authenticated employee's token to call the BFF. -->
  <app-chat-widget />
}
